<div *ngIf="!readonly">
    <button (click)="delModal.show()" [class.btn-img]="imageOnly" class="btn btn-light" id="deletedata{{context}}"
            title="{{ 'COMMON_UI.ENTWURF_LOESCHEN.LOESCHEN' | translate }}" type="button">
        <em class="icon icon-svg icon-fi-papierkorb"></em>
        <span *ngIf="!imageOnly">{{ 'COMMON_UI.ENTWURF_LOESCHEN.LOESCHEN' | translate }}</span>
    </button>

    <div #delModal="bs-modal" bsModal class="modal fade" id="deletedataDialog{{context}}" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title pull-left">{{ 'COMMON_UI.ENTWURF_LOESCHEN.TITEL' | translate }}</h3>
                    <button (click)="onCancelDraft()" class="close pull-right" id="canceldeletedata{{context}}"
                            type="button">
                    </button>
                </div>
                <div class="modal-body">
                    <p>
                        {{ 'COMMON_UI.ENTWURF_LOESCHEN.MESSAGESTART' | translate }} {{clientName}} {{ 'COMMON_UI.ENTWURF_LOESCHEN.MESSAGEEND' | translate }}
                    </p>
                    <div class="d-flex flex-row p-2 justify-content-end mt-4">
                        <button (click)="onDeleteDraft()" [disabled]="disableDelete" class="btn btn-danger mr-4"
                                type="button">
                            {{ 'COMMON_UI.ENTWURF_LOESCHEN.LOESCHEN' | translate }}
                        </button>
                        <button (click)="onCancelDraft()" class="btn btn-default" type="button">
                            {{ 'COMMON_UI.ENTWURF_LOESCHEN.ABBRECHEN' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
